import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Select, SelectModule } from 'primeng/select';
import { BaseFilterWithOptionsComponent } from '../base-filter-with-options/base-filter-with-options.component';
import { FilterState } from '@ui/shared/domain-filter';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-multi-select-filter',
    templateUrl: './multi-select-filter.component.html',
    styleUrls: ['./multi-select-filter.component.scss', '../filter-element/filter-element.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
    ],
})
export class MultiSelectFilterComponent extends BaseFilterWithOptionsComponent {
    @ViewChild('MultiSelect')
    public multiselect?: Select;

    constructor(activeFilterService: FilterState) {
        super(activeFilterService);

        activeFilterService.closeAllOverlays$
            .pipe(
                takeUntilDestroyed(),
            )
            .subscribe(() => {
                this.multiselect?.hide();
            });
    }
}
